const userUnpaidReducer = (
    state = {
        all_counts: {},
    },
    action,
) => {
    switch (action.type) {
        case 'USER_UNPAID':
            console.log('action types', action.list)
            return {
                ...state,
                all_counts: action.list,
            }
        default:
            return state
    }
}

export default userUnpaidReducer
